import { render, staticRenderFns } from "./IconSettingsSubscription.vue?vue&type=template&id=915db1b4&"
import script from "./IconSettingsSubscription.vue?vue&type=script&lang=js&"
export * from "./IconSettingsSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915db1b4')) {
      api.createRecord('915db1b4', component.options)
    } else {
      api.reload('915db1b4', component.options)
    }
    module.hot.accept("./IconSettingsSubscription.vue?vue&type=template&id=915db1b4&", function () {
      api.rerender('915db1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsSubscription.vue"
export default component.exports